import React, { useState } from 'react';
import {
  WysiwygField,
  useDialog,
} from '@uncinc/uncinc-react-kitchen-sink';

import { DialogDrawerContext } from '../../context/DialogDrawerContext';
import DialogDrawer from '../DialogDrawer';

export interface InformationOverlayProps {
  overlayKey: string;
  title?: string,
  body?: string,
  buttonClassName?: string,
  buttonIcon?: string,
  buttonTitle?: string,
  children?: React.ReactNode,
}

import './style.scss';

const InformationOverlay: React.FC<InformationOverlayProps> = (props) => {
  const {
    overlayKey,
    title,
    body,
    buttonIcon,
    buttonTitle,
    buttonClassName = '',
    children,
  } = props;
  const dialogDrawer = useDialog();
  const [dialogActive, setDialogActive] = useState(false);

  return (
    <DialogDrawerContext.Provider value={dialogDrawer}>
      <DialogDrawer.Button type="button" className={buttonClassName} onClick={() => setDialogActive(true)}>
        <i className={`dialogOpenIcon icon icon-${buttonIcon || 'question-circle'}`} />
        {buttonTitle && buttonTitle}
      </DialogDrawer.Button>
      {dialogActive && (
        <DialogDrawer className="InformationOverlay" id={overlayKey}>
          <div className="InformationOverlay__wrapper">
            {title && (
              <div className="InformationOverlay__title">
                <h2>{title}</h2>
              </div>
            )}
            <div className="InformationOverlay__body">
              {body && (
                <WysiwygField
                  property="schema:text"
                  html={body}
                />
              )}
              {children}
            </div>
          </div>
        </DialogDrawer>
      )}
    </DialogDrawerContext.Provider>
  );
};

export default InformationOverlay;
